import { ApiError, parseApiError } from '@app/shared/models/api/api-error.model';
import { Model } from '@app/shared/models/model.interface';

export class PaymentModel implements Model {
  public id: string;
  public orderId: string;
  public paymentProvider: string;
  public paymentMethod: string;
  public paymentState: string;
  public fullName: string;
  public chargeAmount: number;
  public currency: string;
  public postActionLink: string;
  // PAYPAL ORDER ID
  public paymentGatewayRefId?: string | null;
  public paymentError?: ApiError | null;

  // STRIPE PAYMENT SECRET
  public paymentSecret?: string | null;

  /**
   * Constructor to initialize the properties
   * - Make sure the properties are initialized (to avoid unexpected undefined values)
   * @constructor
   */
  constructor() {
    this.id = '';
    this.orderId = '';
    this.paymentProvider = '';
    this.paymentMethod = '';
    this.paymentState = '';
    this.fullName = '';
    this.chargeAmount = 0;
    this.currency = '';
    this.postActionLink = '';
  }

  /**
   * Helper function to sanitize the data that comes from the Backend.
   * @param data The Raw JSON Object
   * @returns {PaymentConfigurationModel} An instance of the payment configuration class.
   */
  public static fromJson(data?: Record<string, any> | null): PaymentModel | null {
    let payment: PaymentModel | null = null;
    if (data) {
      payment = new PaymentModel();
      payment.id = data.id || '';
      payment.orderId = data.orderId || data.order_id || '';
      payment.paymentProvider = data.paymentProvider || data.payment_provider || '';
      payment.paymentMethod = data.paymentMethod || data.payment_method || '';
      payment.paymentState = data.paymentState || data.payment_state || '';
      payment.fullName = data.fullName || data.full_name || '';
      payment.chargeAmount = data.chargeAmount || data.charge_amount || 0;
      payment.currency = data.currency || '';
      payment.postActionLink = data.postActionLink || data.post_action_link || '';

      payment.paymentSecret =
        data.paymentSecret || data.payment_gateway_client_secret || null;

      if (data.paymentGatewayRefId || data.payment_gateway_ref_id) {
        payment.paymentGatewayRefId =
          data.paymentGatewayRefId || data.payment_gateway_ref_id;
      }

      if (data.paymentError || data.payment_error) {
        payment.paymentError = parseApiError(data.paymentError || data.payment_error);
      }
    }
    return payment;
  }
}
